import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

export default function PlatformWebhooks() {
  const tenant = JSON.parse(localStorage.getItem('platform_tenant') || '{}');
  const [webhookUrl, setWebhookUrl] = useState('');

  return (
    <div className="max-w-2xl" data-testid="platform-webhooks-page">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Webhooks</h1>
        <p className="text-gray-500 mt-1">Get notified when events happen on your platform</p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-testid="inbound-webhook-section">
        <h3 className="text-base font-semibold text-gray-900 mb-1">Inbound Webhook URL</h3>
        <p className="text-sm text-gray-500 mb-4">MFB sends bank deposit notifications to this URL. Configure this in your Assets MFB dashboard.</p>
        <code className="block bg-gray-50 px-4 py-3 rounded-lg text-sm font-mono text-gray-700 border" data-testid="inbound-webhook-url">
          https://www.pebbles.financial/api/platform/webhooks/mfb/{tenant.slug || 'your-slug'}
        </code>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-testid="outbound-webhook-section">
        <h3 className="text-base font-semibold text-gray-900 mb-1">Your Webhook URL</h3>
        <p className="text-sm text-gray-500 mb-4">We'll send events (wallet.credited, transfer.completed, etc.) to this URL.</p>
        <input type="url" value={webhookUrl} onChange={e => setWebhookUrl(e.target.value)}
          data-testid="webhook-url-input"
          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#E8678B]/20 focus:border-[#E8678B] mb-3"
          placeholder="https://your-backend.com/webhooks/pebbles" />
        <button onClick={() => toast.info('Webhook URL saved (endpoint coming soon)')}
          data-testid="save-webhook-btn"
          className="px-4 py-2 bg-[#E8678B] text-white rounded-lg text-sm font-semibold hover:bg-[#d15a7d] flex items-center gap-2">
          <Save size={16} /> Save
        </button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6" data-testid="webhook-events-section">
        <h3 className="text-base font-semibold text-gray-900 mb-3">Webhook Events</h3>
        <div className="space-y-2">
          {['wallet.credited', 'wallet.debited', 'transfer.completed', 'transfer.failed'].map(evt => (
            <div key={evt} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded-lg" data-testid={`webhook-event-${evt}`}>
              <code className="text-sm font-mono text-gray-700">{evt}</code>
              <span className="text-xs text-gray-400">Automatic</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
